export default __webpack_public_path__ + "static/media/SndLowerOMagicC.592c80ca.mp3";